import { render } from "./GroupPromoUsageTable.vue?vue&type=template&id=1b68928a&scoped=true"
import script from "./GroupPromoUsageTable.vue?vue&type=script&lang=js"
export * from "./GroupPromoUsageTable.vue?vue&type=script&lang=js"

import "./GroupPromoUsageTable.vue?vue&type=style&index=0&id=1b68928a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b68928a"]])

export default __exports__